import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Validatable } from './validatable'
import { FormValidationService } from './form-validation-service'

@Component({
  selector: 'ValidatedCheckbox',
  templateUrl: './html-templates/validated-checkbox.component.html'
})
export class ValidatedCheckboxComponent extends Validatable<any> {
    @Input() label = ''
    @Input() id = ''
    @Input() checked: boolean
    @Input() disabled: boolean
    @Output() onValueChange = new EventEmitter<boolean>()

  constructor(formValidationService: FormValidationService) {
    super(formValidationService)
  }

  getValue(): boolean {
    return this.checked
  }

  getLabel(): string {
    return this.label
  }

  getId(): string {
    return this.id
  }

    onChange(newValue: boolean) {
    this.checked = newValue; 
    this.validate()
    this.onValueChange.emit(newValue)
  }
}
